import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from 'react-router-scroll-top';
import './style.css';
import App from './components/App';
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";

const store = createStore(rootReducer, applyMiddleware(thunk));

render((
  <BrowserRouter>
    <ScrollToTop>
      <Provider store={store}><App /></Provider>
    </ScrollToTop>
  </BrowserRouter>
), document.getElementById('root'));
